import { setSafe, deleteOrNop } from "../../../util/storeHelper";
import * as actions from "../actions/persistent";
/**
 * Reducer for health check persistent state
 */
export const persistentReducer = {
    reducers: {
        [actions.setRequirementHidden]: (state, payload) => {
            const { modId, requirementId, hidden } = payload;
            const currentHidden = state.hiddenRequirements?.[modId] || [];
            if (hidden && !currentHidden.includes(requirementId)) {
                return setSafe(state, ["hiddenRequirements", modId], [...currentHidden, requirementId]);
            }
            else if (!hidden && currentHidden.includes(requirementId)) {
                const filtered = currentHidden.filter((id) => id !== requirementId);
                if (filtered.length === 0) {
                    // Remove the mod entry entirely if no more hidden requirements
                    return deleteOrNop(state, ["hiddenRequirements", modId]);
                }
                return setSafe(state, ["hiddenRequirements", modId], filtered);
            }
            return state;
        },
        [actions.setAllModRequirementsHidden]: (state, payload) => {
            const { modId, requirementIds } = payload;
            if (requirementIds.length === 0) {
                return deleteOrNop(state, ["hiddenRequirements", modId]);
            }
            return setSafe(state, ["hiddenRequirements", modId], requirementIds);
        },
        [actions.clearAllHiddenRequirements]: (state) => {
            return setSafe(state, ["hiddenRequirements"], {});
        },
        [actions.setModRequirementsEnabled]: (state, payload) => {
            return setSafe(state, ["modRequirementsEnabled"], payload.enabled);
        },
        [actions.setFeedbackGiven]: (state, payload) => {
            const { modId, requirementId } = payload;
            const current = state.feedbackGiven?.[modId] || [];
            if (current.includes(requirementId)) {
                return state;
            }
            return setSafe(state, ["feedbackGiven", modId], [...current, requirementId]);
        },
    },
    defaults: {
        hiddenRequirements: {},
        feedbackGiven: {},
        modRequirementsEnabled: true,
    },
};
